import { JustificativaModal } from '@components/Modal/JustificativaModal';
import { IForm } from '@hooks/useForm';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IJustificativaRequest } from '@hooks/useRequest';
import {IDespesa} from '@model/Despesa';
import { useDespesaService } from '@services/DespesaService';
import { AxiosResponse } from 'axios';
import React from 'react';

export type DespesaCancelarModalProps = {
    modal: IModalWindow
    despesa: IDespesa
    onDespesaCancelada: (response: AxiosResponse<IDespesa>) => void
}

export function DespesaCancelarModal ({ modal, despesa, onDespesaCancelada }: DespesaCancelarModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const despesaService = useDespesaService();

    const handleConfirm = React.useCallback((values: IJustificativaRequest, form: IForm<IJustificativaRequest>)  => {
        if (!loading.isLoading) {
            loading.start();
            despesaService.cancelar(despesa.despesaId, values)
                .then(response => {
                    message.success("Despesa cancelada com sucesso");
                    modal.close();
                    onDespesaCancelada(response);
                })
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(form.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop);
        }
    }, [despesa.despesaId, despesaService, loading, message, modal, onDespesaCancelada]);

    return (
        <JustificativaModal 
            confirmText="Cancelar Despesa"
            disabled={loading.isLoading}
            modal={modal}
            onConfirm={handleConfirm}
            title={`Cancelamento da Despesa ${despesa.despesaId}`}
        />
    )
}